import { RefreshCw } from "lucide-react";

interface PullToRefreshProps {
  pullDistance: number;
  isRefreshing: boolean;
  threshold?: number;
}

export function PullToRefresh({ 
  pullDistance, 
  isRefreshing, 
  threshold = 80 
}: PullToRefreshProps) {
  if (pullDistance === 0 && !isRefreshing) return null;

  const progress = Math.min(pullDistance / threshold, 1);
  const rotation = progress * 360;
  const opacity = Math.min(progress, 1);
  const scale = 0.5 + progress * 0.5;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 flex justify-center pointer-events-none"
      style={{ 
        height: `${pullDistance}px`,
        transition: isRefreshing ? 'none' : 'height 0.2s ease-out',
      }}
    >
      <div 
        className="flex items-center justify-center w-10 h-10 rounded-full bg-primary text-primary-foreground shadow-lg mt-4"
        style={{
          opacity,
          transform: `scale(${scale}) rotate(${rotation}deg)`,
          transition: isRefreshing ? 'none' : 'transform 0.1s ease-out',
        }}
      >
        <RefreshCw className={`h-5 w-5 ${isRefreshing ? 'animate-spin' : ''}`} />
      </div>
    </div>
  );
}
